import { render, staticRenderFns } from "./NetworkAds.vue?vue&type=template&id=fed12472&scoped=true&"
import script from "./NetworkAds.vue?vue&type=script&lang=js&"
export * from "./NetworkAds.vue?vue&type=script&lang=js&"
import style0 from "./NetworkAds.vue?vue&type=style&index=0&id=fed12472&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fed12472",
  null
  
)

export default component.exports